module.exports = __webpack_public_path__ + "assets/svg/Icons/32/reports-gray-56d934.svg";